<script>
  import { onMount } from 'svelte'
  import { fade } from 'svelte/transition'
  import { nrkArrowRight } from '@nrk/core-icons'
  import { kategorier as kategorierStore } from '../../stores/kategorier'
  import { currentRoute } from '../../stores/router'
  import intersecting from '@/actions/intersecting'
  import Link from '../router/link.svelte'

  let showScrollButton = false
  let nav

  let kategorier
  const unsubscribe = currentRoute.subscribe((value) => {
    kategorier = $kategorierStore.map((kategori) => ({
      ...kategori,
      active: kategori.slug === value.params?.slug,
    }))
  })

  onMount(() => {
    // show scroll button if nav is not visible
    let navRect = nav.getBoundingClientRect()
    showScrollButton = window.scrollY > navRect.top + navRect.height

    // scroll active nav element into view
    const scrollContainer = nav.querySelector('ul')
    const scrollContainerRect = scrollContainer.getBoundingClientRect()
    const activeEl = nav.querySelector('.active')
    if (activeEl != null) {
      const activeElRect = activeEl.getBoundingClientRect()
      if (
        activeElRect.left > scrollContainerRect.width ||
        activeElRect.left + activeElRect.width < 0
      ) {
        activeEl.scrollIntoView({ block: 'end', inline: 'center' })
      }
    }

    return () => unsubscribe()
  })
</script>

<style>
  nav {
    max-width: 800px;
    margin: 0 auto;
    overflow-x: scroll;
  }
  ul {
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    margin: 0;
    white-space: nowrap;
    padding: 2px 0 10px;
  }
  li {
    list-style: none;
    background: var(--nav-background);
    color: var(--nav-foreground);
    padding: 2px 14px;
    border-radius: 23px;
    font-size: 17px;
    text-align: center;
    margin: 0 5px 10px;
  }

  li.active {
    background: var(--nav-active-background);
    color: var(--nav-active-foreground);
    font-weight: 600;
  }

  li::after {
    display: block;
    content: attr(data-title);
    font-weight: 600;
    height: 1px;
    color: transparent;
    overflow: hidden;
    visibility: hidden;
  }

  li :global(a) {
    text-decoration: none;
  }

  p {
    font-size: 20px;
    color: var(--primary);
    margin: 0;
    padding-left: 22px;
    position: sticky;
    left: 0;
  }

  @media (min-width: 600px) {
    nav {
      overflow-x: hidden;
    }

    ul {
      flex-wrap: wrap;
    }

    p {
      padding-left: 20px;
    }
  }

  @media (max-width: 600px) {
    li:first-of-type {
      margin-left: 6px;
    }
    li:last-of-type {
      margin-right: 6px;
    }
    li {
      margin-bottom: 0;
    }
  }

  .scrollbutton {
    position: fixed;
    bottom: 50px;
    right: 16px;
    border-radius: 50%;
    width: 64px;
    height: 64px;
    transform: rotate(-90deg);
    background: var(--interaction-cta);
    border: 0;
    color: #fff;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    z-index: 99;
    padding: 10px;
  }
</style>

<nav
  bind:this={nav}
  use:intersecting={{ rootMargin: '0px 0px 0px 0px' }}
  on:enter={() => {
    showScrollButton = false
  }}
  on:leave={() => {
    showScrollButton = true
  }}>
  <p>Jeg vil ...</p>
  <ul>
    <li class:active={$currentRoute.name === 'landing'} data-title="se lyspunkter">
      <Link to="landing" active={$currentRoute.name === 'landing'}>se lyspunkter</Link>
    </li>
    {#each kategorier as { navn, slug, active }}
      <li class:active data-title={navn}>
        <Link to="kategori" params={{ slug }} {active}>{navn}</Link>
      </li>
    {/each}
  </ul>
</nav>

{#if showScrollButton}
  <button
    transition:fade={{ duration: 200 }}
    on:click={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    class="scrollbutton"
    tabIndex="-1"
    aria-hidden="true"
    title="Gå til toppen">
    {@html nrkArrowRight}
  </button>
{/if}
